import React, { useContext, useState } from "react";
import { Alert, Button, Col, Container, Form, Row } from "react-bootstrap";
import { VscNewFile } from "react-icons/vsc";
import { BsArrowLeft, BsSearch } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

import Cabecalho from "../../../components/Cabecalho/Cabecalho";
import BoletimInformacoes from "./components/BoletimInformacoes";
import LoadSpinner from "../../../components/LoadSpinner/LoadSpinner";
import { BoletimContext } from "../../../context/BoletimContext";
import api from "../../../Utils/api";
import { hasPermission } from "../../../Utils/permissions";
import "../styles/dashboard-modern.css";
import "./styles/dashboard-boletim.css";

const DashboardBoletim = () => {
  const navigate = useNavigate();
  const { boletim, setBoletim, discardCurrentDraft, syncStatus } = useContext(BoletimContext);
  const [filters, setFilters] = useState({ date: "", number: "", involved: "", keyword: "" });
  const [reports, setReports] = useState([]);
  const [searched, setSearched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const canViewAll = hasPermission("boletins.view.all");

  const updateFilter = (field) => (event) =>
    setFilters((current) => ({ ...current, [field]: event.target.value }));

  const searchReports = async (event) => {
    event.preventDefault();
    const params = Object.fromEntries(
      Object.entries(filters).filter(([, value]) => value.trim())
    );
    if (!Object.keys(params).length) {
      setError("Preencha ao menos um campo para pesquisar.");
      setReports([]);
      setSearched(false);
      return;
    }

    setError("");
    setIsLoading(true);
    setSearched(true);
    try {
      const { data } = await api.get("/incidentReport/search", { params });
      setReports(data);
    } catch (requestError) {
      setReports([]);
      setError(requestError.response?.data?.message || "Não foi possível pesquisar os boletins.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickNovoBoletim = async () => {
    const newBoletim = {
      municipio: localStorage.getItem("x-user-municipio") || "Balsas",
      envolvidos: [],
      materiaisApreendidos: [],
      efetivo: [],
      historicohtml: "",
    };
    const hasDraft = syncStatus.state !== "synced" && (
      boletim.numero || boletim.data || boletim.natureza || boletim.historicohtml ||
      boletim.envolvidos?.length || boletim.materiaisApreendidos?.length || boletim.efetivo?.length
    );
    if (hasDraft && !window.confirm("Há um boletim em andamento. Deseja descartá-lo e iniciar outro?")) {
      navigate("/boletim/header");
      return;
    }
    if (hasDraft) await discardCurrentDraft();
    setBoletim(newBoletim);
    navigate("/boletim/header");
  };

  return (
    <>
      <Cabecalho />
      <main className="dashboard-modern mt-3 mb-5">
        <Container>
          <div className="search-page-heading">
            <div>
              <p className="dashboard-eyebrow">Consulta de registros</p>
              <h2>Pesquisar boletins</h2>
              <p className="dashboard-intro">
                {canViewAll
                  ? "Pesquise os boletins disponíveis para sua conta de administrador."
                  : "A pesquisa exibe apenas os boletins que você registrou."}
              </p>
            </div>
          </div>

          <Form className="report-search-form" onSubmit={searchReports}>
            <Row className="g-3">
              <Col xs={12} sm={6} lg={3}>
                <Form.Group>
                  <Form.Label>Data do fato</Form.Label>
                  <Form.Control type="date" value={filters.date} onChange={updateFilter("date")} />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} lg={3}>
                <Form.Group>
                  <Form.Label>Número do boletim</Form.Label>
                  <Form.Control inputMode="numeric" value={filters.number} onChange={updateFilter("number")} placeholder="Número" />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} lg={3}>
                <Form.Group>
                  <Form.Label>Envolvido</Form.Label>
                  <Form.Control value={filters.involved} onChange={updateFilter("involved")} placeholder="Nome do envolvido" />
                </Form.Group>
              </Col>
              <Col xs={12} sm={6} lg={3}>
                <Form.Group>
                  <Form.Label>Palavra-chave</Form.Label>
                  <Form.Control value={filters.keyword} onChange={updateFilter("keyword")} placeholder="Natureza, local ou relato" />
                </Form.Group>
              </Col>
            </Row>
            {error && <Alert variant="danger" className="mt-3 mb-0">{error}</Alert>}
            <div className="d-flex flex-column flex-sm-row gap-2 mt-3">
              <Button type="submit" className="search-submit" disabled={isLoading}>
                <BsSearch className="me-2" /> Pesquisar
              </Button>
              <Button type="button" variant="outline-secondary" onClick={() => navigate("/dashboard")}>
                <BsArrowLeft className="me-2" /> Voltar
              </Button>
            </div>
          </Form>

          <LoadSpinner visible={isLoading} />
          {searched && !isLoading && !error && reports.length === 0 && (
            <Alert variant="info" className="mt-4">Nenhum boletim encontrado com os filtros informados.</Alert>
          )}
          {reports.map((report) => (
            <BoletimInformacoes key={report._id} boletim={report} setBoletim={setBoletim} />
          ))}

          <Row className="justify-content-center mt-4">
            <Col xs={12} sm={7} md={5} className="d-grid">
              <Button variant="dark" onClick={handleClickNovoBoletim}>
                Registrar ocorrência <VscNewFile />
              </Button>
            </Col>
          </Row>
        </Container>
      </main>
    </>
  );
};

export default DashboardBoletim;
